import Phaser from 'phaser';
import { INK, INK_NUM, PAPER_NUM, MUTED } from '../systems/ui/chrome.js';
import levels from '../../data/levels.json';

function formatTime(ms) {
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${String(m).padStart(2, '0')}:${String(rem).padStart(2, '0')}`;
}

export class LevelComplete extends Phaser.Scene {
  constructor() {
    super('LevelComplete');
  }

  init(data) {
    this.levelId = data.levelId;
    this.timeMs = data.timeMs;
    this.score = data.score;
    this.chipsCollected = data.chipsCollected ?? 0;
    this.chipsTotal = data.chipsTotal ?? 0;
    this.nextId = data.nextId;
  }

  create() {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor('#ffffff');

    this.add
      .text(width / 2, height * 0.17, 'LEVEL COMPLETE', {
        fontFamily: 'monospace',
        fontSize: '22px',
        fontStyle: 'bold',
        color: INK
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.17 + 26, levels[this.levelId]?.name ?? this.levelId, {
        fontFamily: 'monospace',
        fontSize: '10px',
        color: MUTED
      })
      .setOrigin(0.5);

    const statsY = height * 0.4;
    this.add.rectangle(width / 2, statsY, 200, 70, PAPER_NUM, 1).setStrokeStyle(1, INK_NUM);
    this.add
      .text(
        width / 2,
        statsY,
        `TIME  ${formatTime(this.timeMs)}\nSCORE ${this.score}\nCHIPS ${this.chipsCollected}/${this.chipsTotal}`,
        {
          fontFamily: 'monospace',
          fontSize: '11px',
          fontStyle: 'bold',
          color: INK,
          align: 'center',
          lineSpacing: 5
        }
      )
      .setOrigin(0.5);

    let y = height * 0.62;
    const makeButton = (label, onClick) => {
      const box = this.add
        .rectangle(width / 2, y, 190, 28, PAPER_NUM, 0)
        .setStrokeStyle(1, INK_NUM)
        .setInteractive({ useHandCursor: true });
      const text = this.add
        .text(width / 2, y, label, { fontFamily: 'monospace', fontSize: '11px', fontStyle: 'bold', color: INK })
        .setOrigin(0.5);
      box.on('pointerover', () => {
        box.setFillStyle(INK_NUM, 1);
        text.setColor('#ffffff');
      });
      box.on('pointerout', () => {
        box.setFillStyle(PAPER_NUM, 0);
        text.setColor(INK);
      });
      box.on('pointerdown', onClick);
      y += 34;
      return box;
    };

    if (this.nextId) {
      makeButton('▶  NEXT LEVEL', () => this.scene.start('Game', { levelId: this.nextId }));
    }
    makeButton('↻  RETRY', () => this.scene.start('Game', { levelId: this.levelId }));
    makeButton('☰  LEVEL SELECT', () => this.scene.start('LevelSelect'));
  }
}
